@use "src/sedestral/sass/mixins/texts";
@use "src/sedestral/sass/icons/icons";

.componentWebsiteBlackCasesFlow {
  .union {
    visibility: visible;
  }

  .description {
    font-size: 27px;
    max-width: 980px;
    color: var(--white);
    margin-bottom: 40px;
    z-index: 1;
    position: relative;

    @include texts.font("semi-bold");

    span {
      color: var(--web-green);
    }
  }

  @media screen and (max-width: 930px) {
    .description {
      font-size: 22px !important;
      width: 100% !important;
    }
  }
}